<template>
    <footer class="bg-secondary p-2">
        <div class="container d-flex justify-content-between align-items-center flex-wrap ">
            <div class="col-12 col-sm-4">
                <small class="text-white fw-bold">
                    ATB MOBILITA' S.P.A - società per azioni
                </small>
            </div>
            <div class="col-12 col-sm-4">
                <small class="text-white fw-bold">
                    ATB SERVIZI S.P.A - società per azioni con socio unico
                </small>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterComp'
}
</script>